import FormControl from "../base/FormControl";

export default class InputMonth extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "month";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}